import { render, staticRenderFns } from "./TaskTotalCosts.vue?vue&type=template&id=ca7f7470&"
import script from "./TaskTotalCosts.vue?vue&type=script&lang=js&"
export * from "./TaskTotalCosts.vue?vue&type=script&lang=js&"
import style0 from "./TaskTotalCosts.vue?vue&type=style&index=0&id=ca7f7470&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports